import { Security, safeAbsurd } from '@ipfabric/utils';
import { array } from 'fp-ts';

export const getSecurityTestChildren = (
  node: Security.Test,
): Security.Test[] => {
  if (Security.isAndGroupTest(node) || Security.isOrGroupTest(node)) {
    return node.items;
  }
  if (Security.isNotGroupTest(node)) {
    return [node.item];
  }
  if (Security.isReferencedTest(node)) {
    return array.empty;
  }
  if (Security.isSimpleTest(node)) {
    return array.empty;
  }
  if (Security.isEvalTest(node)) {
    return array.empty;
  }
  safeAbsurd(node, 'unknown security tree test node type');
  return array.empty;
};
